import React from 'react';
import Dashboard from './Dashboard';
import TenantDashboard from './TenantDashboard';
import useAuth from '../hooks/useAuth';

export default function DashboardRouter() {
  const { user } = useAuth();

  if (user?.role === 'superadmin') return <Dashboard />;
  if (user?.role === 'tenantAdmin') return <TenantDashboard />;
  return <div className="p-6 text-red-600">Access denied.</div>;
}
